/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Question/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Question({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Answer/Question",
  isDisabled,
  isHovered
  
}) {
let widgetQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'questions',
})
let answerPromptValueData = fromData.useDataValue({ viewPath,
context: 'answer',
path: 'prompt',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let aggregateData = fromHelpers.populateTemplate(widgetQuestionsValueData, answerPromptValueData, selectedAnswersValueData)
let dtQuestionColorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Question.color.brand.base'
        })
let dtTypographyFontsizeS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtQuestionColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Question.color.brand.hovered'
        })
let dtQuestionColorBrandDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Question.color.brand.disabled'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={isHovered ? dtQuestionColorBrandHovered : dtQuestionColorBrandBase}
 fontSize={dtTypographyFontsizeS}
 fontWeight={200}
 marginBottom={dtSpaceXxs}
 data="widget.questions"
 data="answer.prompt"
 data="selected.answers"
 aggregate="helpers.js populateTemplate"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}